import comp0 from '@/app/scriptconsent'
import comp1 from '@/app/cookieconsent'
import comp2 from '@/app/cookiebanner'
import comp3 from '@/app/sentry'
import comp4 from '@/app/countryredirect'
import comp5 from '@/app/abandonoptout'
import comp6 from '@/app/accountpage'
import comp7 from '@/app/countdown'
import comp8 from '@/app/highlightproducts'
import comp9 from '@/app/bgvideo'
import comp10 from '@/app/scrollto'
import comp11 from '@/app/howtosteam'
import comp12 from '@/app/marquee'
import comp13 from '@/app/contentslider'
import comp14 from '@/app/locations'
import comp15 from '@/app/toggleoverlay'
import comp16 from '@/app/loginform'
import comp17 from '@/app/registerform'
import comp18 from '@/app/selforderinglogin'
import comp19 from '@/app/migrationverify'
import comp20 from '@/app/migration'
import comp21 from '@/app/parallax'
import comp22 from '@/app/revealleadtext'
import comp23 from '@/app/scrollingmarquee'
import comp24 from '@/app/imageslider'
import comp25 from '@/app/steamvideos'
import comp26 from '@/app/stickyleadtext'
import comp27 from '@/app/teaserslider'
import comp28 from '@/app/tierlevelslider'
import comp29 from '@/app/video'
import comp30 from '@/app/vouchersbuy'
import comp31 from '@/app/checkout'
import comp32 from '@/app/shoplist'
import comp33 from '@/app/newsletterform'
import comp34 from '@/app/dialog'
import comp35 from '@/app/loaderglobal'
import comp36 from '@/app/header'
import comp37 from '@/app/shopnav'
import comp38 from '@/app/loginwidget'
import comp39 from '@/app/cartwidget'
import comp40 from '@/app/loginregisteroverlay'
import comp41 from '@/app/sidebarcart'
import comp42 from '@/app/faq'
import comp43 from '@/app/message'
import comp44 from '@/app/passwordresetform'
import comp45 from '@/app/toggleclass'
var map={}; 
map['app/scriptconsent']=comp0;
map['app/cookieconsent']=comp1;
map['app/cookiebanner']=comp2;
map['app/sentry']=comp3;
map['app/countryredirect']=comp4;
map['app/abandonoptout']=comp5;
map['app/accountpage']=comp6;
map['app/countdown']=comp7;
map['app/highlightproducts']=comp8;
map['app/bgvideo']=comp9;
map['app/scrollto']=comp10;
map['app/howtosteam']=comp11;
map['app/marquee']=comp12;
map['app/contentslider']=comp13;
map['app/locations']=comp14;
map['app/toggleoverlay']=comp15;
map['app/loginform']=comp16;
map['app/registerform']=comp17;
map['app/selforderinglogin']=comp18;
map['app/migrationverify']=comp19;
map['app/migration']=comp20;
map['app/parallax']=comp21;
map['app/revealleadtext']=comp22;
map['app/scrollingmarquee']=comp23;
map['app/imageslider']=comp24;
map['app/steamvideos']=comp25;
map['app/stickyleadtext']=comp26;
map['app/teaserslider']=comp27;
map['app/tierlevelslider']=comp28;
map['app/video']=comp29;
map['app/vouchersbuy']=comp30;
map['app/checkout']=comp31;
map['app/shoplist']=comp32;
map['app/newsletterform']=comp33;
map['app/dialog']=comp34;
map['app/loaderglobal']=comp35;
map['app/header']=comp36;
map['app/shopnav']=comp37;
map['app/loginwidget']=comp38;
map['app/cartwidget']=comp39;
map['app/loginregisteroverlay']=comp40;
map['app/sidebarcart']=comp41;
map['app/faq']=comp42;
map['app/message']=comp43;
map['app/passwordresetform']=comp44;
map['app/toggleclass']=comp45;
export default map;